import React from 'react';

import * as styles from './enroll.module.scss';

const AgentPortalUserWarning: React.FC = () => {
  const [isVisible, setIsVisible] = React.useState(false);

  // display after initial render to avoid hydration errors
  React.useEffect(() => {
    setIsVisible(Boolean(document.cookie.match('is_agent_portal_user=true')));
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <p className={styles.warning}>
      If you are a broker enrolling a client, please{' '}
      <a
        href="https://agent.devoted.com/applications/add"
        rel="noopener noreferrer"
        target="_blank">
        start enrollment on the Agent Portal
      </a>
      . This application is for self-enrollments.
    </p>
  );
};

export default AgentPortalUserWarning;
